import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"
// import FileDownload from 'js-file-download';

const obj = {

    addReceptor: async (params) => {

        // console.log("addReceptor", params);
        // return;
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(apiurl + "receptorfactura",
            {
                ...params
            }
            ,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
    getReceptores: async (filtros) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        const params = {};
        if (filtros.rutsv) params.rut = filtros.rutsv;
        if (filtros.rutExacto) params.rutExacto = filtros.rutExacto;
        if (filtros.razon_social) params.razon_social = filtros.razon_social;
        if (filtros.ciudad) params.ciudad = filtros.ciudad;
        if (filtros.comuna) params.comuna = filtros.comuna;
        if (filtros.page) params.page = filtros.page;
        if (filtros.limit) params.limit = filtros.limit;


        return axios.get(apiurl + "receptorfactura", {
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            params,
            crossdomain: true,
        });
    },
    updateReceptor: async (params) => {

        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.put(apiurl + "receptorfactura",
            {
                ...params
            }
            ,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
    deleteReceptor: async (rut) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.delete(`${apiurl}receptorfactura`, {
            params: {
                rut: rut
            },
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            crossdomain: true
        });
    },
    getTransportesReceptor: async (receptor_id) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.get(`${apiurl}receptorfactura/transportes`, {
            params: {
                receptor_id
            },
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            crossdomain: true
        });
    },
    deleteTransporte: async (receptor_id, patente) => {
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.delete(`${apiurl}receptorfactura/transportes`, {
            params: {
                receptor_id,
                patente
            },
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
            crossdomain: true
        });
    },
    addTransporte: async (params) => {

        console.log("addTransporte params:", params);
        // return;
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(apiurl + "receptorfactura/transportes",
            {
                ...params
            }
            ,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
};

export default obj;